import React from "react";
import { Icon, Text } from "@bookingcom/bui-react";
import { CheckmarkIcon } from "@bookingcom/bui-assets-react/streamline";
import { pricingUtils } from "@flights/web-api-utils-universal";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
export function AvailabilityIndicator({ availability, currencyCode }) {
    const i18n = useI18n();
    switch (availability) {
        case "INCLUDED":
            return (React.createElement(Icon, { size: "medium", svg: CheckmarkIcon, color: "constructive", attributes: { "aria-label": i18n.trans(t("a11y_flights_sr_bf_tabular_hover_incl_icon")) } }));
        case "SELLABLE":
            return (React.createElement(Text, { variant: "small_1", attributes: { role: "img", "aria-label": i18n.trans(t("a11y_flights_bf_currency_icon")) } }, pricingUtils.getCurrencySymbol(currencyCode)));
        case "NOT_INCLUDED":
            return (React.createElement(Text, { variant: "small_1", attributes: { role: "img", "aria-label": i18n.trans(t("a11y_flights_sr_bf_tabular_hover_excl_icon")) } }, "-"));
        default:
            return (React.createElement(Text, { variant: "small_1", attributes: {
                    role: "img",
                    "aria-label": i18n.trans(t("a11y_flights_sr_bf_tabular_hover_unavailable_feature"))
                } }, " "));
    }
}
